<template>
  <span class="svg-icon-gif-tab" :style="iconStyle">
    <svg class="icon-color-1" :style="`width:${width}px; height:${width}px; fill:none;`" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.5415 10.6667H7.81234C7.979 10.6667 8.12137 10.6042 8.23942 10.4792C8.35748 10.3542 8.4165 10.2083 8.4165 10.0417V9.20833H7.7915V10.0417H6.5415V7.95833H8.37484C8.37484 7.79167 8.31928 7.64583 8.20817 7.52083C8.09706 7.39583 7.95817 7.33333 7.7915 7.33333H6.5415C6.36095 7.33333 6.21164 7.39236 6.09359 7.51042C5.97553 7.62847 5.9165 7.77778 5.9165 7.95833V10.0417C5.9165 10.2222 5.97553 10.3715 6.09359 10.4896C6.21164 10.6076 6.36095 10.6667 6.5415 10.6667ZM9.354 10.6667H9.979V7.33333H9.354V10.6667ZM10.9165 10.6667H11.5415V9.41667H12.9998V8.79167H11.5415V7.95833H13.4165V7.33333H10.9165V10.6667ZM3.4165 16.5C3.08317 16.5 2.7915 16.375 2.5415 16.125C2.2915 15.875 2.1665 15.5833 2.1665 15.25V2.75C2.1665 2.41667 2.2915 2.125 2.5415 1.875C2.7915 1.625 3.08317 1.5 3.4165 1.5H15.9165C16.2498 1.5 16.5415 1.625 16.7915 1.875C17.0415 2.125 17.1665 2.41667 17.1665 2.75V15.25C17.1665 15.5833 17.0415 15.875 16.7915 16.125C16.5415 16.375 16.2498 16.5 15.9165 16.5H3.4165ZM3.4165 15.25H15.9165V2.75H3.4165V15.25Z" fill="#212121"/>
    </svg>
  </span>
</template>

<script>
import { computed } from 'vue'
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  },

  computed: {
    iconStyle () {
      return {
        '--iconColor': this.color,
        'width': `${this.width}px`,
        'height': `${this.width}px`,
        'fill': 'none'
      }
    }
  }
}
</script>

<style lang="scss">
  .svg-icon-gif-tab {
    display: flex;
    justify-content: left;
    align-items: center;

    path {
      fill: var(--iconColor)
    }
  }
</style>
